import { Chip } from "@material-ui/core";
import Translator from "Languages/Utility/Translator";
import React, { Fragment } from "react";

function ActiveFormatter({row}) {
    return (
        <Fragment>
            <Chip
                className={row.Active ? "success" : "danger"}
                label={
                    row.Active ? <Translator id="active" /> : <Translator id="disable" />
                }
            />
        </Fragment>
    );
}

export default ActiveFormatter;
